// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3RHNr","dragIcon":"Choice_dragIcon__3bDTL","left":"Choice_left__hxWEW","input":"Choice_input__152Aa"};